import React from "react";
import { Search, PenTool, Code2, Rocket } from "lucide-react";

const steps = [
  { icon: Search, title: "Discover", text: "We understand your goals, users and requirements to define a clear scope and roadmap." },
  { icon: PenTool, title: "Design", text: "Architecture, data models and UI/UX are planned for scalability and a clean experience." },
  { icon: Code2, title: "Develop", text: "Agile milestone-based development with weekly updates, testing and code reviews." },
  { icon: Rocket, title: "Deploy & Support", text: "Hosting, domain, SSL and production launch — followed by ongoing maintenance." },
];

export const Process = () => {
  return (
    <section id="process" className="relative bg-[#070b18] py-24 overflow-hidden">
      <div className="absolute bottom-0 right-1/3 w-[420px] h-[420px] rounded-full bg-blue-700/10 blur-[130px]" />
      <div className="relative max-w-6xl mx-auto px-4">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <span className="eyebrow reveal">How We Work</span>
          <h2 className="reveal d1 mt-5 font-display text-white text-3xl md:text-5xl">
            A proven <span className="text-gradient">process</span>
          </h2>
          <p className="reveal d2 mt-4 text-slate-400 text-base md:text-lg">
            Transparent, milestone-driven delivery from idea to production.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* connecting line */}
          <div className="hidden md:block absolute top-8 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />

          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className={`reveal d${i + 1} relative text-center`}>
                <div className="relative mx-auto h-16 w-16 rounded-2xl glass-strong grid place-items-center mb-6">
                  <Icon className="h-7 w-7 text-blue-400" strokeWidth={2.3} />
                  <span className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-gradient-to-br from-blue-600 to-violet-600 text-white text-xs font-black grid place-items-center">
                    {i + 1}
                  </span>
                </div>
                <h3 className="text-lg font-extrabold text-white">{s.title}</h3>
                <p className="mt-2 text-slate-400 text-sm leading-relaxed px-2">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
